import { z } from "zod";
import { SectionSpacingSchema } from "../../../../../zod/shared-schemas.mjs";
const FeatureSectionBannersSliderItemSchema = z.object({
  textColor: z.enum(["light", "dark"]).optional().nullable(),
  images: z.object({
    mobile: z.object({
      src: z.string().optional().nullable(),
      alt: z.string().optional().nullable()
    }).optional().nullable(),
    desktop: z.object({
      src: z.string().optional().nullable(),
      alt: z.string().optional().nullable()
    }).optional().nullable()
  }).optional().nullable(),
  title: z.string().optional().nullable(),
  description: z.string().optional().nullable(),
  button: z.object({
    link: z.string().optional().nullable(),
    text: z.string()
  }).optional().nullable()
});
const FeatureSectionBannersSliderSchema = z.object({
  id: z.string().optional().nullable(),
  items: FeatureSectionBannersSliderItemSchema.array()
}).merge(SectionSpacingSchema);
export default FeatureSectionBannersSliderSchema;
